import React from "react";
import { Divider } from "semantic-ui-react";
import ProjectList from "../lists/ProjectList";
import { ProjectCreateButton } from "../buttons";

const Dashboard = () => (
  <>
    <ProjectCreateButton />
    <Divider />
    <ProjectList />
  </>
);

export default Dashboard;
